<mat-form-field
  [appearance]="model.getAdditional('appearance', 'legacy')"
  [color]="model.getAdditional('color', 'primary')"
  [formGroup]="group"
  [hideRequiredMarker]="model.getAdditional('hideRequiredMarker', false)"
  [ngClass]="getClass('grid', 'control')"
>
  <mat-chip-listbox #matChipList [formControlName]="model.id" [id]="id" [multiple]="true">
    @for (chip of chips; track chip; let index = $index) {
    <mat-chip [selectable]="false" (removed)="onChipRemoved(chip, index)">
      <span>{{ chip }}</span>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
    }

    <input
      matInput
      [matAutocomplete]="matAutocomplete"
      [matChipInputAddOnBlur]="model.getAdditional('matChipInputAddOnBlur', true)"
      [matChipInputFor]="matChipList"
      [matChipInputSeparatorKeyCodes]="
        model.getAdditional('matChipInputSeparatorKeyCodes', CHIPS_OPTIONS['separatorKeyCodes'])
      "
      [placeholder]="model.placeholder"
      (matChipInputTokenEnd)="onChipInputTokenEnd($event)"
      (blur)="onBlur($event)"
      (focus)="onFocus($event)"
    />

    <mat-autocomplete
      #matAutocomplete="matAutocomplete"
      [autoActiveFirstOption]="
        model.getAdditional('autoActiveFirstOption', AUTOCOMPLETE_OPTIONS['autoActiveFirstOption'])
      "
      [disableRipple]="model.getAdditional('disableRipple', (RIPPLE_OPTIONS && RIPPLE_OPTIONS['disabled']) || false)"
      [displayWith]="model.getAdditional('displayWith', null)"
      (optionSelected)="onChipSelected($event)"
    >
      @for (option of model.list$ | async; track option) {
      <mat-option [value]="option">{{ option }}</mat-option>
      }
    </mat-autocomplete>
  </mat-chip-listbox>
</mat-form-field>
